export default __webpack_public_path__ + "media/images/Masto-B2-CarnavalRio-f139c9ccc6d3abca5e0038aa503bd55a.png";